import React, { useState } from 'react';
import { axiosInstance } from '../App';
import { toast } from 'sonner';

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axiosInstance.post('/auth/login', {
        username: formData.username,
        password: formData.password
      });
      onLogin(response.data.token, response.data.user);
      toast.success('Login successful!');
    } catch (error) {
      const detail = error.response?.data?.detail;
      if (error.response?.status === 423) {
        toast.error(detail || 'Account locked. Try again later.');
      } else {
        toast.error(detail || 'An error occurred');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cb-login-page">
      <div className="cb-login-hero">
        <div className="cb-login-halo" aria-hidden="true" />
        <img src="/coinbills-cmark.svg" alt="" className="cb-login-logo" data-testid="login-logo" />
      </div>

      <h1 className="cb-login-title">Private Wealth</h1>
      <p className="cb-login-sub">Sign in to continue</p>

      <form onSubmit={handleSubmit} className="cb-login-form space-y-4">
        <div>
          <label className="cb-login-label">Username</label>
          <input
            type="text"
            data-testid="login-username-input"
            className="cb-login-input"
            value={formData.username}
            onChange={(e) => setFormData({ ...formData, username: e.target.value })}
            placeholder="Enter your username"
            required
          />
        </div>

        <div>
          <label className="cb-login-label">Password</label>
          <input
            type="password"
            data-testid="login-password-input"
            className="cb-login-input"
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            required
          />
        </div>

        <button
          type="submit"
          data-testid="login-submit-button"
          className="cb-login-btn"
          disabled={loading}
        >
          {loading ? 'Please wait...' : 'Login'}
        </button>
      </form>

      <div className="cb-login-footer">Private Wealth</div>
    </div>
  );
};

export default Login;
